import { render } from "./ContactosView.vue?vue&type=template&id=07f29db6&ts=true"
import script from "./ContactosView.vue?vue&type=script&lang=ts"
export * from "./ContactosView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__